import React, { useContext } from 'react';
import styled from 'styled-components';
import { Typography, Space, Divider, Alert } from 'antd';
import { ApplicationUIContext } from '@yuhuinc/ui-library';

const { Title } = Typography;

const SpaceFullWidth = styled(Space)`
  width: 100%;

  .ant-space-item > .ant-space-vertical {
    width: 100%;
  }
`;

const CardContentWithDividers = (props) => {
  return <SpaceFullWidth direction="vertical" split={<Divider />} size={0} {...props} />;
};

const TitleWithoutMarginTop = styled(Title)`
  margin-top: 0;
`;

const CardSectionTitle = (props) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return <TitleWithoutMarginTop level={isMobile ? 4 : 5} {...props} />;
};

const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  > .ant-typography {
    margin: 0;
  }
`;

const StyledStatisticGroup = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? `display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;`
      : `display: flex;
  gap: 16px 40px;
  flex-wrap: wrap;`}

  .ant-statistic-content {
    font-size: 14px;
    font-family: inherit;
  }
`;

const StyledAlert = styled(Alert)`
  .ant-alert-message {
    font-size: ${({ isMobile }) => (isMobile ? '20px' : '16px')};
  }

  .ant-alert-description {
    font-size: ${({ isMobile }) => (isMobile ? '16px' : '14px')};
  }

  .ant-alert-description p {
    margin-bottom: 8px;
  }

  .ant-alert-description .ant-btn.ant-btn-link {
    padding: 0;
  }
`;

export { StyledAlert };
export { SpaceFullWidth };
export { CardSectionTitle, CardContentWithDividers };
export { StyledHeader, StyledStatisticGroup };
